import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentRequestOnlineAttemptModel } from '../entity/paymentRequestOnlineAttempt.model';
import {AbstractActionService} from "../../../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";
import {Payload} from "../../../../../../core/service/payload/payload";
import {PaymentRequestOnlineAttemptConverter} from "../entity/converter/paymentRequestOnlineAttempt.converter";
import {PayloadWithId} from "../../../../../../core/service/payload/payloadWithId";

@Injectable()
export class PaymentRequestOnlineAttemptRefreshStatusActionService extends AbstractActionService<PayloadWithId, PaymentRequestOnlineAttemptModel> {
    constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                httpClient: HttpClient,
                private converter: PaymentRequestOnlineAttemptConverter) {
        super('PaymentRequestOnlineAttempt', 'refresh-status', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): PaymentRequestOnlineAttemptModel {
        return this.converter.convert(response);
    }
}
